<template>
  <div class="row reverse-mobile justify-content-center">
    <UserMenu></UserMenu>

    <div class="col-12 col-md-9 center-content">
      <CommunityCard class="p-4">
        <div class="d-flex mb-4">
          <h3 class="text-inherit">My Scenarios</h3>
          <div class="ml-auto">
            <button
              class="btn btn-primary"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img
                src="../assets/add.svg"
                class="mr-2"
                alt="add scenario icon"
              />
              Add Scenario
            </button>
            <div class="dropdown-menu">
              <router-link
                :to="{ name: 'scenarios-upload' }"
                class="dropdown-item"
              >
                Upload Scenario
              </router-link>
              <a v-if="!isOnNative" :href="webEditorUrl" class="dropdown-item">
                Create Scenario
              </a>
            </div>
          </div>
        </div>

        <div v-if="isLoading">
          <PleaseWait :bgColour="'#FFFFFF'"></PleaseWait>
        </div>

        <div v-if="scenariosCount <= 0 && !isLoading">
          <NoContributed is-scenario="true"></NoContributed>
        </div>

        <div v-else>
          <div class="placeholder">
            <Scenario
              v-cloak
              v-bind:key="scenario.id"
              v-for="scenario in scenarioObjects"
              :scenario="scenario"
              :currentlySelectedTags="scenarioTags"
              :is-my-scenario="true"
            ></Scenario>
          </div>

          <div class="row d-flex justify-content-center">
            <div
              v-if="scenariosCount > 0"
              class="pagination-wrapper col-12 d-flex justify-content-end mt-3 mr-5"
            >
              <template>
                <paginate
                  v-model="page"
                  :page-count="pageCount"
                  :page-range="3"
                  :margin-pages="2"
                  :click-handler="clickCallback"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                  :page-class="'page-item'"
                ></paginate>
              </template>
            </div>
          </div>
        </div>
      </CommunityCard>

      <Footer />
    </div>
  </div>
</template>

<script>
import ScenService from "../services/scenarios.service";
import Paginate from "../components/Paginate";
import Scenario from "../components/Scenario";
import UserMenu from "../components/UserMenu";
import ScenarioObject from "../objects/ScenarioObject";
import NoContributed from "../components/NoContributed";
import PleaseWait from "../components/PleaseWait";
import CommunityCard from "../components/CommunityCard";
import Footer from "../components/Footer";

export default {
  name: "MyScenarios",
  components: {
    Scenario,
    UserMenu,
    Paginate,
    NoContributed,
    PleaseWait,
    CommunityCard,
    Footer,
  },
  data() {
    return {
      isLoading: true,
      NUMBER_TO_GET: 5,
      pageCount: 0,
      page: 0,
      from: 0,
      to: 0,
      scenarios: [],
      scenarioTags: [],
      scenariosCount: 0,
      pageNum: 0,
      scenarioObjects: [],
      isActive: false,
      sortByFields: [
        { id: "dateAsc", name: "Created Date ▼", isSelected: true },
        { id: "dateDesc", name: "Created Date ▲", isSelected: false },
        { id: "nameAsc", name: "Name ▼", isSelected: false },
        { id: "nameDesc", name: "Name ▲", isSelected: false },
      ],
      currentSortByName: "Created Date ▼",
      webEditorUrl: process.env.VUE_APP_CONTROL_DOMAIN,
    };
  },
  beforeMount() {
    this.isLoading = true;
    this.getScenarios();
  },
  computed: {
    isOnNative() {
      return this.$store.getters.getIsOnNative;
    },
  },
  watch: {
    "$route.params.directoryUuid"() {
      this.getScenarios();
    },
  },
  methods: {
    sortBy(sorter) {
      this.currentSortByName = sorter.name;
      this.sortByFields.forEach((x) => (x.isSelected = false));
      sorter.isSelected = true;

      let sortDir = sorter.id.includes("Asc") ? "ASC" : "DESC";
      let sortBy = sorter.id.includes("date") ? "contributedAt" : "name";

      // page zero and one are the same
      let startAtPage = this.page < 2 ? 0 : this.page - 1;

      this.getScenarios(this.NUMBER_TO_GET * startAtPage, sortBy, sortDir);
    },

    getScenarios(startAt, sortBy, sortDirection) {
      this.isLoading = true;
      this.isActive = true;
      ScenService.myScenarios(
        startAt,
        this.NUMBER_TO_GET,
        sortBy,
        sortDirection,
        this.$route.params.directoryUuid
      ).then((data) => {
        this.scenariosCount = data.total;
        this.scenarioObjects = [];
        for (let scenario in data.scenarios) {
          this.scenarioObjects.push(
            new ScenarioObject(data.scenarios[scenario])
          );
        }
        this.from = parseInt(data.from);
        this.to = parseInt(data.to);
        this.updatePageCount();
        this.isLoading = false;
      });

      this.isActive = false;
    },
    clickCallback(pageNum) {
      this.isActive = true;

      window.scrollTo(0, 0);
      this.page = pageNum;
      pageNum = pageNum - 1;
      this.scenarioObjects = [];

      let currentSorter = this.sortByFields.find((x) => x.isSelected);
      let sortDir = currentSorter.id.includes("Asc") ? "ASC" : "DESC";
      let sortBy = currentSorter.id.includes("date") ? "contributedAt" : "name";

      this.getScenarios(this.NUMBER_TO_GET * pageNum, sortBy, sortDir);
    },
    updateFavouriteScenariosList() {
      this.$parent.updateFavouriteScenariosList();
    },
    updatePageCount() {
      this.pageCount = Math.ceil(this.scenariosCount / this.NUMBER_TO_GET);
    },
  },
};
</script>

<style scoped>
.placeholder {
  min-height: 300px;
  z-index: 9;
  margin-bottom: 30px;
}

/* Medium Devices, Desktops */
@media only screen and (max-width: 992px) {
  .pagination-wrapper {
    margin: 0 !important;
    padding: 0 !important;
    display: flex;
  }
  .pagination-wrapper ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>
